const productSlidesConfig = [
  { id: 'product1', label: 'Product', },
  { id: 'product2', label: 'Performance', },
  { id: 'product3', label: 'Drawdown Analysis', },
  { id: 'product4', label: 'Top 10', },
  { id: 'product5', label: 'Details', },
]

export default productSlidesConfig